/* Form page to edit a Sceneule Scene */
import React, { useEffect, useState } from "react"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import styles from "../../../styles/ScheduleCreate.module.css"
import btnStyles from "../../../styles/Button.module.css"
import { Alert } from "react-bootstrap"
import { useHistory, useParams } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../../api/axiosDefaults"
import TopBox from "../../../components/TopBox"
import { useRedirect } from "../../../hooks/Redirect"
import { CLIENT_PROGRAM_HOSTNAME } from "../../../utils/config"
import useHostName from "../../../hooks/useHostName"
import toast from "react-hot-toast";

const SceneScheduleEdit2 = () => {
  const host = useHostName()
  useRedirect()
  const [errors, setErrors] = useState({})
  const { id } = useParams()
  const history = useHistory()

  const [postData, setPostData] = useState({
    scene_id: "",
    day_id: "",
    day_order_number: "",
    start_time: "",
    end_time: "",
    number: "",
    location: "",
    int_ext: "",
    day_night: "",
    action: "",
    filming_location: "",
    location_address: "",
    time: "",
    title: "",
    department_info: "",
    equip_set_props: "",
    act: "",
    next: "",
    new_info: "",
  })

  const {
    // scene_id,
    day_id,
    day_order_number,
    number,
    act,
    title,
    int_ext,
    start_time,
    end_time,
    day_night,
    action,
    location,
    filming_location,
    location_address,
    time,
    equip_set_props,
    department_info,
    next,
    new_info,
  } = postData

  useEffect(() => {
    const handleMount = async () => {
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const { data } = await axiosReq.get(`/schedule/scenes/${id}/`)

          const {
            scene_id,
            day_id,
            time,
            day_order_number,
            number,
            act,
            title,
            int_ext,
            start_time,
            end_time,
            day_night,
            action,
            location,
            filming_location,
            location_address,
            equip_set_props,
            department_info,
            next,
            new_info,
          } = data

          setPostData({
            scene_id,
            day_id,
            time,
            day_order_number,
            number,
            act,
            title,
            int_ext,
            start_time,
            end_time,
            day_night,
            action,
            location,
            filming_location,
            location_address,
            equip_set_props,
            department_info,
            next,
            new_info,
          })
        } else {
          const { data } = await axiosInstance.get(
            `${localStorage.getItem("projectSlug")}/schedule/scenes/${id}/`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          )

          const {
            scene_id,
            day_id,
            day_order_number,
            number,
            act,
            title,
            int_ext,
            start_time,
            end_time,
            day_night,
            action,
            location,
            filming_location,
            location_address,
            time,
            equip_set_props,
            department_info,
            next,
            new_info,
          } = data

          setPostData({
            scene_id,
            day_id,
            day_order_number,
            number,
            act,
            title,
            int_ext,
            start_time,
            end_time,
            day_night,
            action,
            location,
            filming_location,
            location_address,
            time,
            equip_set_props,
            department_info,
            next,
            new_info,
          })
        }
      } catch (err) {
        console.log(err)
      }
    }

    handleMount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData()

    formData.append("scene_id", '')
    formData.append("day_id", day_id)
    formData.append("day_order_number", day_order_number)
    formData.append("number", number)
    formData.append("act", act)
    formData.append("title", title)
    formData.append("start_time", start_time)
    formData.append("end_time", end_time)
    formData.append("int_ext", int_ext)
    formData.append("day_night", day_night)
    formData.append("action", action)
    formData.append("location", location)
    formData.append("filming_location", filming_location)
    formData.append("location_address", location_address)
    formData.append("time", time)
    formData.append("equip_set_props", equip_set_props)
    formData.append("department_info", department_info)
    formData.append("next", next)
    formData.append("new_info", new_info)
    formData.append("is_second_unit", true);
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosReq.put(`/schedule/scenes/${id}/`, formData)
        toast.success(`Schedule Scene Updated`);
        history.goBack()
      } else {
        await axiosInstance.put(
          `${localStorage.getItem("projectSlug")}/schedule/scenes/${id}/`,
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        toast.success(`Schedule Scene Updated Successfully!`);
        history.goBack()
      }
    } catch (err) {
      console.log(err)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data)
      }
    }
  }

  const textFields = (
    <div>
      {/*  Description - using action
             bg using title
             Stunts/SFX - using department_info  
             shoot info - using new_info  */}
      {/* order start est */}
      <Row>
        <Col xs={12} md={4} className="p-0 p-md-2">
          <p className={`${styles.BoldScene}`}>Order Number</p>
          <p className={`${styles.Number} pt-1`}>Reorder using Drag and Drop</p>
        </Col>
        <Col xs={6} md={4} className="d-flex justify-content-center mt-3 mt-md-0 p-0 p-md-2">
          <Form.Group controlId="start_time" className={`${styles.Width2} `}  >
            <Form.Label className={`${styles.BoldScene}`} >Start Time</Form.Label>
            <Form.Control
              className={`${styles.Input}`}
              type="text"
              name="start_time"
              value={start_time}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.start_time?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={6} md={4} className="d-flex justify-content-center mt-3 mt-md-0 p-0 p-md-2">
          <Form.Group controlId="end_time" className={`${styles.Width2} `}  >
            <Form.Label className={`${styles.BoldScene}`} >Est. Time</Form.Label>
            <Form.Control
              className={`${styles.Input}`}
              type="text"
              name="end_time"
              value={end_time}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.end_time?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
      {/* hr */}
      <hr />
      {/* scene number - scene loc - int-ext - day-night */}
      <Row>
        <Col xs={6} md={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="number" className={`${styles.Width2} `}  >
            <Form.Label className={`${styles.BoldScene}`} >Scene Number</Form.Label>
            <Form.Control
              className={`${styles.Input}`}
              type="text"
              name="number"
              value={number}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.number?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={6} md={3} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="location" className={`${styles.Width2} `}  >
            <Form.Label className={`${styles.BoldScene}`} >Scene Location</Form.Label>
            <Form.Control
              className={`${styles.Input}`}
              type="text"
              name="location"
              value={location}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.location?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2" xs={6} md={3} >
          <Form.Group controlId="int_ext" className={`${styles.Width2} `} >
            <Form.Label className={`${styles.BoldScene}`} >Int-Ext</Form.Label>
            <Form.Control as="select"
              className={styles.InputEx}
              name="int_ext"
              value={int_ext}
              onChange={handleChange}
              aria-label="int ext select">
              <option></option>
              <option value="int.">Int</option>
              <option value="ext.">Ext</option>
            </Form.Control>
          </Form.Group>
          {errors?.int_ext?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2" xs={6} md={3} >
          <Form.Group controlId="day_night" className={`${styles.Width2} `} >
            <Form.Label className={`${styles.BoldScene}`} >Day/Night</Form.Label>
            <Form.Control as="select"
              name="day_night"
              className={styles.InputEx}
              value={day_night}
              onChange={handleChange}
              aria-label="day or night select">
              <option></option>
              <option value="DAY">Day</option>
              <option value="NIGHT">Night</option>
            </Form.Control>
          </Form.Group>
          {errors?.day_night?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
      {/* hr */}
      <hr />
      {/*  footage  */}
      <Row>
        <Col xs={12} md={{ span: 10, offset: 1 }} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="action" className={`${styles.Width2} `}  >
            <Form.Label className={`${styles.BoldScene}`} >Footage Description</Form.Label>
            <Form.Control
              className={`${styles.InputScene}`}
              type="text"
              name="action"
              value={action}
              as="textarea"
              rows={2}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.action?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
      <hr />
      {/*  filming location name - address - parking using time */}
      <Row>
        <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="filming_location" className={`${styles.Width2} `}  >
            <Form.Label >
              <p className={`${styles.BoldScene}`}>Filming Location Name</p>
            </Form.Label>
            <Form.Control
              className={`${styles.Input}`}
              type="text"
              name="filming_location"
              value={filming_location}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.filming_location?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={12} md={4} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="location_address" className={`${styles.Width2} `}  >
            <Form.Label className={`${styles.BoldScene}`} >Filming Location Address</Form.Label>
            <Form.Control
              className={`${styles.InputScene}`}
              type="text"
              name="location_address"
              as="textarea"
              rows={2}
              value={location_address}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.location_address?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={12} md={4} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="time" className={`${styles.Width2} `}  >
            <Form.Label className={`${styles.BoldScene}`} >Parking/Directions/Notes</Form.Label>
            <Form.Control
              className={`${styles.InputScene}`}
              type="text"
              name="time"
              as="textarea"
              rows={2}
              value={time}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.time?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
      <hr />
      {/* bg using title - equip - stunts using department_info */}
      <Row>
        <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="title" className={`${styles.Width2} `}  >
            <Form.Label className={`${styles.BoldScene}`} >BG/Doubles/Stunt Artists</Form.Label>
            <Form.Control
              className={`${styles.InputScene}`}
              type="text"
              name="title"
              value={title}
              as="textarea"
              rows={1}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.title?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={12} md={4} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="equip_set_props" className={`${styles.Width2} `}  >
            <Form.Label className={`${styles.BoldScene}`}>Equipment/Set/Props</Form.Label>
            <Form.Control
              className={`${styles.InputScene}`}
              type="text"
              name="equip_set_props"
              as="textarea"
              rows={1}
              value={equip_set_props}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.equip_set_props?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={12} md={4} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="department_info" className={`${styles.Width2} `}  >
            <Form.Label >
              <p className={`${styles.BoldScene}`}>Stunts/SFX</p>
            </Form.Label>
            <Form.Control
              className={`${styles.InputScene}`}
              type="text"
              name="department_info"
              as="textarea"
              rows={1}
              value={department_info}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.department_info?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
      {/* hr */}
      <hr />
      {/* cast using act - shoot info using new_info - next */}
      <Row>
        <Col xs={12} md={4} className="d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="act" className={`${styles.Width2} `}  >
            <Form.Label >
              <p className={`${styles.BoldScene}`}>Cast</p>
              <p className={`${styles.Para3}`}>Coordinate with Main Unit</p>
            </Form.Label>
            <Form.Control
              className={`${styles.InputScene}`}
              type="text"
              name="act"
              as="textarea"
              rows={1}
              value={act}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.act?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={12} md={4} className="mt-3 mt-md-0 d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="new_info" className={`${styles.Width2} `}  >
            <Form.Label className={`${styles.BoldScene}`}>Shoot Info</Form.Label>
            <Form.Control
              className={`${styles.InputScene}`}
              type="text"
              name="new_info"
              as="textarea"
              rows={1}
              value={new_info}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.new_info?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={12} md={4} className="mt-4 mt-md-0 d-flex justify-content-center p-0 p-md-2">
          <Form.Group controlId="next" className={`${styles.Width2} `}  >
            <Form.Label >
              <p className={`${styles.BoldScene}`}>Next</p>
              <p className={`${styles.Para3}`}>Add Moves and Meal Breaks here</p>
            </Form.Label>
            <Form.Control
              className={`${styles.InputSceneNext}`}
              type="text"
              name="next"
              as="textarea"
              rows={1}
              value={next}
              onChange={handleChange}
            />
          </Form.Group>
          {errors?.next?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
      {/* hr */}
      <hr />
    </div>
  )

  const buttons = (
    <div className="text-center mt-4">
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} mr-3 px-3 px-md-5`}
        onClick={() => history.goBack()}
      >
        Cancel
      </Button>
      <Button
        className={`px-4 ml-2 ${btnStyles.Button} ${btnStyles.Blue} ml-3 px-3 px-md-5`}
        type="submit"
      >
        Update
      </Button>
    </div>
  )

  return (
    <div className={` ${styles.FormBox} `}>
      <TopBox work="Second Unit"
        title="Edit Schedule Scene" />
      <Row>
        <Col>
          <Button
            className={`${btnStyles.Button} ${btnStyles.Blue} mt-2 mb-1`}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <h3 className="text-center">2nd Unit - Edit Scene {number} </h3>
          <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`} />
        </Col>
      </Row>
      <Form
        className={`px-3 pb-3 mt-1 mb-4 text-center ${styles.FormBox} `}
        onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} className="p-0 p-md-2">
            {textFields}
            {buttons}
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export default SceneScheduleEdit2
